// FRONTEND REACT (Chatbox avancée avec image, texte et date)

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { jsPDF } from "jspdf";
import logo from "../images/mydata.jpg";
import ResponseBox from "../components/ResponseBox";

export default function AdvancedChatbox() {
  const [text, setText] = useState("");
  const [date, setDate] = useState("");
  const [image, setImage] = useState(null);
  const [response, setResponse] = useState("");
   const [responseUrl, setResponseUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();

  // ⬇️ téléchargement PDF basé sur le state "response"
  const handleDownload = () => {
    const doc = new jsPDF();

    // Charger le logo
    const imgLogo = new Image();
    imgLogo.src = logo;

    imgLogo.onload = async () => {
      doc.addImage(imgLogo, "PNG", 10, 10, 30, 30);

      doc.setFontSize(16);
      doc.text(t("Synthèse MyDataCheck"), 105, 20, { align: "center" });

      doc.setLineWidth(0.5);
      doc.line(10, 40, 200, 40);

      doc.setFontSize(12);
      let yPos = 50;
      doc.text(t("Données saisies :"), 10, yPos);
      if (text) doc.text(`- Texte : ${text}`, 10, yPos + 10);
      if (date) doc.text(`- Date : ${date}`, 10, yPos + 20);
      yPos += 40;

      // Image
      if (image) {
        const base64Img = await fileToBase64(image);
        doc.text(t("Image fournie :"), 10, yPos);
        yPos += 10;
        doc.addImage(base64Img, "JPEG", 10, yPos, 60, 60);
        yPos += 70;
      }

      // Réponse du chatbot
      doc.text(t("Réponse du chatbot :"), 10, yPos);
      yPos += 10;

      const splitResponse = doc.splitTextToSize(
        response || "Aucune réponse",
        180,
      );

      // Pagination automatique
      const pageHeight = doc.internal.pageSize.height;
      splitResponse.forEach((line) => {
        if (yPos > pageHeight - 20) {
          // 20 = marge bas
          doc.addPage();
          yPos = 20; // nouvelle page, marge top
        }
        doc.text(line, 10, yPos);
        yPos += 7; // espace entre lignes
      });

      doc.save(t("synthese.pdf"));
    };
  };

  // Helper pour convertir File -> base64
  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponse("");
    const formData = new FormData();
    if (text.trim()) formData.append("text", text.trim());
    if (date) formData.append("date", date);
    if (image) formData.append("image", image);

    // endpoint selon la langue active
    const endpoint =
      i18n.language === "en"
        ? "https://mydatacheck.site/api/verifications/chat-verify-en"
        : "https://mydatacheck.site/api/verifications/chat-verify"; // fr par défaut

    try {
      const res = await fetch(endpoint, {
        method: "POST",
        body: formData,
      });

      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(
          errorData.error ||
            "Échec de vérification || nous n'avons rien trouvé",
        );
      }

      const data = await res.json();
      console.log(data);
      setResponse(data.response);
      setResponseUrl(data.url)
    } catch (error) {
      setResponse(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[200vh] pt-8 pb-8 bg-gray-100">
      <div className="max-w-xl min-h-[20vh] mx-auto p-4 border rounded-xl bg-white shadow text-gray-800">
        <h2 className="text-xl font-bold mb-4 text-[#42AB3F]">
          {t("chatbotTitle")}
        </h2>

        {/* Formulaire */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            className="w-full p-2 border rounded dark:text-black"
            placeholder={t("chatbotPlaceholder")}
            value={text}
            onChange={(e) => setText(e.target.value)}
          />

          <input
            type="date"
            className="w-full p-2 border rounded dark:text-black"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />

          <label
            htmlFor="file_input"
            className="block mb-2 text-sm font-medium text-[#42AB3F]"
          >
            {t("chatbotImg")}
          </label>
          <input
            id="file_input"
            type="file"
            className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50"
            onChange={(e) => setImage(e.target.files[0])}
            accept="image/*"
          />

          <p className="mt-1 text-sm text-gray-500" id="file_input_help">
            PNG, JPG (MAX. 5M).
          </p>

          <button
            type="submit"
            className="bg-[#DA6E2f] text-white px-4 py-2 rounded hover:bg-[#452a1b]"
          >
            {t("factcheck3")}
          </button>
        </form>

        {/* Loader */}
        {loading && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/40 backdrop-blur-sm">
            <div className="flex flex-col items-center space-y-2">
              <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-[#DA6E2f]"></div>
              <p className="text-lg font-semibold text-[#DA6E2f]">
                {t("chatbotLoading")}
              </p>
            </div>
          </div>
        )}
      </div>
      {/* Résultat + bouton PDF */}
      {/* {response && (
          <div className=" mt-4 p-3 border rounded bg-gray-200 overflow-x-auto overflow-y-auto ">
            <strong>{t("chatbotResponse")} :</strong>
            <p>{response}</p>

            <button
              onClick={handleDownload}
              className="mt-3 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
            >
              {t("localpdf")}
            </button>
          </div>
        )} */}
      <ResponseBox response={response} url={responseUrl} handleDownload={handleDownload} t={t} />
    </div>
  );
}
